import React from 'react';
import { useEffect, useRef, useState } from 'react';

import { Box, Button, ButtonBase, Chip, IconButton, Typography, CardContent, Card, Dialog, DialogActions, DialogContent, DialogTitle, TextField, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import JourneyCard from './JourneyCard';
import { useData } from '../DataProviderContext';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import EditOutlined from '@mui/icons-material/EditOutlined';
import JourneySuggestion from '../JourneySuggestion';
import { LockedIconButton } from '../SignedInLock';

const STEP_DESCRIPTION_COLLAPSED_HEIGHT = '4.2em';
const TOUCH_TARGET_SX = { minWidth: 44, minHeight: 44 };



const JourneyListView = ({ listroot }) => {
    const { dataState, dispatch } = useData();
    const isGuestPreview = dataState.guestJourneyStatus === 'preview';
    const [open, setOpen] = useState(false);
    const [actionsExpanded, setActionsExpanded] = useState(false);
    const [isStepContentExpanded, setIsStepContentExpanded] = useState(false);
    const previousActionCount = useRef(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const moveItem = (direction) => {
        // do dispatch
        // reorder list 
        // index + direction 
        dispatch({ type: 'REORDER_GOAL', payload: { listroot: listroot, direction: direction } });
    };


    const handleClickDelete = () => {
        //     console.log('DELETE THIS THING');
        //     console.log('cardKEy is ' + cardKey);
        // dispatch({ type: 'REMOVE_SUGGESTION', payload: { keyId: cardKey, step_Id: stepId } });
        dispatch({ type: 'REMOVE_TASK', payload: { listroot: listroot } });

    };

    const handleEdit = () => {
        setOpen(true);
        //     console.log('DELETE THIS THING');
        //     console.log('cardKEy is ' + cardKey);
        //   removeClientSideItem({ keyId: cardKey });



    };

    const handleStepContentKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (isGuestPreview) setIsStepContentExpanded(true);
            else handleEdit();
        } else if (event.key === 'Escape') {
            event.preventDefault();
            setIsStepContentExpanded(false);
        }
    };

    const handleStepContentTouchEnd = () => {
        setIsStepContentExpanded((current) => !current);
    };




    const handleClose = () => {
        setOpen(false);
    };


    if (listroot === null) {
        listroot = 0;
    }


    var objective = dataState.userDocs.steps[listroot].objective;
    var objectiveDescription = dataState.userDocs.steps[listroot].objectiveDescription;
    const actions = dataState.userDocs.steps[listroot].items;
    const actionCount = actions.length;
    const hasCollapsedActions = actionCount > 5;
    const visibleActions = actionsExpanded ? actions : actions.slice(0, 5);

    useEffect(() => {
        if (previousActionCount.current !== null && actionCount > previousActionCount.current) {
            setActionsExpanded(true);
        }
        previousActionCount.current = actionCount;
    }, [actionCount]);

    console.log("IS THIS THE IT");

    console.log(dataState.userDocs.steps[listroot]);

    var stepId = dataState.userDocs.steps[listroot].step_id;
    // find list root from user Docs
    // if it cant be found default to this one

    const renderHeader = () => (
        <Box sx={{ width: '100%', minWidth: 0, pb: 2.5, mb: 2.5, borderBottom: 1, borderColor: 'divider' }}>
            {/* <Typography variant="h5" component="div">
                    LIST ROOT {listroot}
                </Typography> */}
            <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Chip size="small" color="primary" variant="outlined" label={`Step ${listroot + 1}`} sx={{ fontWeight: 800 }} />
                    <Box>
                        {isGuestPreview ? <LockedIconButton label="Move step left" sx={TOUCH_TARGET_SX}>
                            <ArrowBack />
                        </LockedIconButton> : <IconButton
                            onClick={() => moveItem(-1)}
                            disabled={listroot === 0}
                            aria-label="Move step left"
                            sx={TOUCH_TARGET_SX}
                        >
                            <ArrowBack />
                        </IconButton>}
                        {isGuestPreview ? <LockedIconButton label="Move step right" sx={TOUCH_TARGET_SX}>
                            <ArrowForward />
                        </LockedIconButton> : <IconButton
                            onClick={() => moveItem( 1)}
                            disabled={listroot === dataState.userDocs.steps.length - 1}
                            aria-label="Move step right"
                            sx={TOUCH_TARGET_SX}
                        >
                            <ArrowForward />
                        </IconButton>}
                    </Box>
                </Stack>
                <ButtonBase
                    data-testid="step-content"
                    aria-label="View full step content. Press Enter to edit."
                    aria-expanded={isStepContentExpanded}
                    onClick={() => {
                        if (!isMobile) setIsStepContentExpanded(true);
                    }}
                    onDoubleClick={() => setIsStepContentExpanded(false)}
                    onTouchEnd={handleStepContentTouchEnd}
                    onKeyDown={handleStepContentKeyDown}
                    sx={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        touchAction: 'manipulation',
                    }}
                >
                    <Typography
                        id={`journey-step-title-${listroot}`}
                        variant="h5"
                        component="h3"
                        data-testid="step-title"
                        sx={{
                            fontWeight: 900,
                            mb: 0.75,
                            overflow: isStepContentExpanded ? 'visible' : 'hidden',
                            textOverflow: isStepContentExpanded ? 'clip' : 'ellipsis',
                            whiteSpace: isStepContentExpanded ? 'pre-wrap' : 'nowrap',
                            overflowWrap: 'anywhere',
                        }}
                    >
                        {objective ? objective : 'Set a Goal'}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        data-testid="step-description"
                        sx={{
                            display: isStepContentExpanded ? 'block' : '-webkit-box',
                            WebkitLineClamp: isStepContentExpanded ? 'unset' : 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: isStepContentExpanded ? 'visible' : 'hidden',
                            textOverflow: isStepContentExpanded ? 'clip' : 'ellipsis',
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            whiteSpace: isStepContentExpanded ? 'pre-wrap' : 'normal',
                            lineHeight: 1.4,
                            minHeight: STEP_DESCRIPTION_COLLAPSED_HEIGHT,
                            maxWidth: '72ch',
                        }}
                    >
                        {objectiveDescription ? objectiveDescription : 'Add a short description for this step.'}
                    </Typography>
                </ButtonBase>
                <Stack direction="row" spacing={1} sx={{ mt: 1.5, justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap', rowGap: 1 }}>
                    {isGuestPreview ? <LockedIconButton label="Edit step" color="primary" data-testid="edit-step" sx={TOUCH_TARGET_SX}>
                        <EditOutlined />
                    </LockedIconButton> : <IconButton
                        color="primary"
                        onClick={(handleEdit)}
                        data-testid="edit-step"
                        aria-label="Edit step"
                        sx={TOUCH_TARGET_SX}
                    >
                        <EditOutlined />
                    </IconButton>}
                    {isGuestPreview ? <LockedIconButton label="Delete step" color="error" data-testid="delete-step" sx={TOUCH_TARGET_SX}>
                        <DeleteOutline />
                    </LockedIconButton> : <IconButton
                        color="error"
                        onClick={(handleClickDelete)}
                        data-testid="delete-step"
                        aria-label="Delete step"
                        sx={TOUCH_TARGET_SX}
                    >
                        <DeleteOutline />
                    </IconButton>}
                </Stack>
        </Box>
    );


    try {


        if (dataState.userDocs) {
            // console.log('UserDoc : ' + JSON.stringify(dataState.userDocs));
            return (<Box sx={{ width: '100%', minWidth: 0 }}>
                <Card
                    component="article"
                    aria-labelledby={`journey-step-title-${listroot}`}
                    sx={{
                        width: '100%',
                        minWidth: 0,
                        borderRadius: 3,
                        boxShadow: 1,
                        bgcolor: 'background.paper',
                        borderTop: 4,
                        borderTopColor: 'primary.main',
                    }}
                    variant="outlined"
                    data-testid="journey-step-card"
                >
                    <CardContent sx={{ p: { xs: 2, sm: 3 }, '&:last-child': { pb: { xs: 2, sm: 3 } } }}>
                        {/* Step description  */}
                        {renderHeader()}

                        {/* List Controls: addNew List, removeList, moveLeft, moveRight, (no clone list)     */}


                        { /*   Top Card for Adding a New Step*/}

                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={1.5}
                            sx={{ justifyContent: 'space-between', alignItems: { xs: 'stretch', sm: 'center' }, mb: 2 }}
                        >
                            <Box>
                                <Typography variant="h6" component="h4" sx={{ fontWeight: 800 }}>
                                    Actions
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Keep each action specific and easy to complete.
                                </Typography>
                            </Box>
                            <JourneySuggestion selectedStep={listroot} objective={{'text':objective , 'description': objectiveDescription}} />
                        </Stack>

                        { /*   Iterate over items to generate cards */}

                    <Stack direction="column" spacing={1.5} data-testid="journey-actions-list">
                            {
                                visibleActions.map((item, index) => {
                                    var objective = { 'text': dataState.userDocs.steps[listroot].objective, 'description': dataState.userDocs.steps[listroot].objectiveDescription };
                                    // return a card instance
                                    return (

                                        <JourneyCard content={item.value} stepId={index} cardOnly={true} key={item.keyID} cardKey={item.keyID} listroot={listroot} objective={  objective} action={item} ></JourneyCard>
                                    )
                                })}
                        </Stack>
                        {hasCollapsedActions ? (
                            <Button
                                type="button"
                                onClick={() => setActionsExpanded((current) => !current)}
                                aria-expanded={actionsExpanded}
                                data-testid="toggle-actions-visibility"
                                sx={{ mt: 2 }}
                            >
                                {actionsExpanded ? 'Show fewer' : `Show all (${actionCount})`}
                            </Button>
                        ) : null}
                    </CardContent>
                </Card>

                <Dialog open={open} onClose={handleClose}
                    fullScreen={isMobile}
                    fullWidth
                    maxWidth={'md'}
                    PaperProps={{
                        component: 'form',
                        onSubmit: (event) => {
                            // invoke firebase here?
                            // put in Quuee to submit
                            event.preventDefault();
                            const formData = new FormData(event.currentTarget);
                            const formJson = Object.fromEntries(formData.entries());
                            const objective = formJson.objective;
                            const descDescription = formJson.objectiveDescription;
                            console.log(objective);
                            dispatch({ type: 'EDIT_TASK', payload: { listroot: stepId, target: dataState.selectedNode, newName: objective, description: descDescription } });

                            //updateClientSideJourney(selectedStep, suggestion);
                            handleClose();
                        },
                    }}>
                    <Box
                        data-testid="edit-step-content-column"
                        sx={{ width: '100%', maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 4, md: 6 }, boxSizing: 'border-box' }}
                    >
                        <DialogTitle sx={{ px: 0 }}>Edit journey step</DialogTitle>
                        <DialogContent sx={{ px: 0, pt: 0 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                Update the title and description for this step.
                            </Typography>
                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="name"
                                name="objective"
                                data-testid="step-title-input"
                                label="Step title"
                                type="text"
                                fullWidth
                                multiline
                                rows={1}
                                variant="outlined"
                                defaultValue={objective ? objective : ''}
                            />
                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="name"
                                name="objectiveDescription"
                                data-testid="step-description-input"
                                label="Brief description"
                                type="text"
                                fullWidth
                                multiline
                                rows={4}
                                variant="outlined"
                                defaultValue={objectiveDescription ? objectiveDescription : ''}
                            />
                        </DialogContent>
                        <DialogActions sx={{ px: 0 }}>
                            <Button type="submit" data-testid="save-step">Save</Button>
                            <Button onClick={handleClose} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Box>
                </Dialog> </Box>
            );
        }

    } catch (error) {
        console.log("Error:" + error);
    }
    return (
        <div>
            <Typography >Empty List fromUser Docs    </Typography>
        </div>
    );

};

export default JourneyListView;
